import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfCategories } from '../../categorySchema'

export default categories => {
    const categoriesData = pathOr([], ['_embedded', 'expediaCategories'], categories)
    return { ...normalize(categoriesData, arrayOfCategories) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/expediaParsers/expediaCategories.js